module.exports = __webpack_public_path__ + "img/ts-favicon.57a2da80.png";